export const scrollToTop = () => {
  document.querySelector('.navbar').scrollIntoView({ behavior: 'smooth' });
};
